import React from 'react';
import { cn } from 'shared/lib/cn';

export type SwitchProps = {
  checked: boolean;
  onChange: (next: boolean) => void;
  ariaLabel: string;
  onLabel?: string;
  offLabel?: string;
  disabled?: boolean;
  className?: string;
};

export function Switch({ checked, onChange, ariaLabel, onLabel = 'On', offLabel = 'Off', disabled, className }: SwitchProps) {
  return (
    <span className={cn('inline-flex items-center gap-2 font-body text-xs', disabled && 'opacity-50', className)}>
      <span className={cn(checked ? 'text-ink-muted' : 'text-ink')}>{offLabel}</span>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={ariaLabel}
        disabled={disabled}
        onClick={() => onChange(!checked)}
        className={cn(
          'relative inline-flex h-5 w-9 items-center rounded-full border border-hairline/30 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand/60',
          checked ? 'bg-brand' : 'bg-surface-high',
          disabled && 'cursor-not-allowed',
        )}
      >
        <span className={cn('inline-block h-4 w-4 rounded-full bg-ink transition-transform', checked ? 'translate-x-4' : 'translate-x-0.5')} />
      </button>
      <span className={cn(checked ? 'text-ink' : 'text-ink-muted')}>{onLabel}</span>
    </span>
  );
}
